export interface CompaniesData {
    campaign: Campaign,
    campaignData: CampaignData,
    campaignContacts: RelationCampaignContacts[],
    campaignUsers: RelationCampaignUsers[],
    scheduler: Scheduler
}

export const CALLS_DIALER_TYPE = {
    sequential: 1,
    cyclically: 2,
    sequentialByCycle: 3,
} as const;

export type CallsDialerType = typeof CALLS_DIALER_TYPE[keyof typeof CALLS_DIALER_TYPE];

export function resolveCallsDialerType(campaign: any): CallsDialerType {
    const rawType = campaign?.callsDialerType;
    if (rawType !== undefined && rawType !== null && rawType !== '') {
        const parsed = Number(rawType);
        if (parsed === CALLS_DIALER_TYPE.sequential || parsed === CALLS_DIALER_TYPE.cyclically || parsed === CALLS_DIALER_TYPE.sequentialByCycle) {
            return parsed;
        }
    }

    if (campaign?.isSequentiallyByCycle) {
        return CALLS_DIALER_TYPE.sequentialByCycle;
    }

    if (campaign?.isCyclically) {
        return CALLS_DIALER_TYPE.cyclically;
    }

    return CALLS_DIALER_TYPE.sequential;
}

export interface Campaign {
    campaignId: number,
    campaignTypeId: number,
    countContacts: number,
    countUsers: number,
    description: string,
    employmentOperators: number,
    isArchived: boolean,
    name: string,
    operatorStrategyTypeId: number,
    priority: number,
    progressCampaign: number,
    progressContacts: null | number,
    schedulerId: number,
    statusId: number,
    wellComplet: number,
    garbageStrategyOperators?: number | null,
    callsDialerType?: CallsDialerType | number
}

export interface CampaignData {
    campaignId: number,
    createdByUserId: string,
    createdDateTime: string,
    updatedByUserId: string,
    updatedDateTime: string,
}

export interface Scheduler {
    dayNumber: number | null,
    daysNumberOfWeek: number | null,
    delay: number,
    endTime: Date | string,
    endDate: Date | string,
    lastDayOfMonth: null,
    monthNumber: null,
    orderWeekday: null,
    schedulerId: number,
    startTime: Date | string,
    startDate: Date | string,
    typeEventEnd: boolean,
    typeEventStart: boolean,
    typeScheduler: number,
    subtypeScheduler: number,
}

export interface RelationCampaignContacts {
    campaignId: number,
    contact: string,
    description: string,
    phoneNo: string,
    phoneTypeId: number
}

export interface RelationCampaignUsers {
    campaignId: number,
    userId: string,
    fullName?: string,
    userLevel?: number,
    userName?: string,
}

export interface UserLoginData {
    userName: string,
    password: string,
    code2FA?: string
}

export interface StateCampaign {
    campaignId: number,
    statusId: number,
    UserId: string
}

export interface MenuItem {
    label: string;
    icon: string;
    to?: string;
    name: string;
    items?: any;
}

export interface DataSort {
    isArchived: boolean;
    pageNumber: number;
    pageSize: number;
    sort: {
        orderBy: string;
        isDesc: boolean;
    };
    filter?: { key: string; value: string }[];
}

export interface RoleDataSort {
    isArchived: boolean;
    pageNumber: number;
    pageSize: number;
    active?: boolean;
    sort: {
        orderBy: string;
        isDesc: boolean;
    };
    filter?: { key: string; value: string }[];
}

export interface StatusByPeriodDataSort {
    pageNumber: number;
    pageSize: number;
    active?: boolean;
    branchId?: number;
    sort: {
        orderBy: string;
        isDesc: boolean;
    };
    filter?: { key: string; value: string }[];
}

export interface DataRow {
    userId: number;
    id: number;
    fullName: string;
    role: string;
    branchName: string;
    direction: string;
    login: string;
    phoneNo: string;
    ownerName: string;
    status: string;
    userName: string;
    lastName: string;
    firstName: string;
    middleName: string;
    roles: any;
    email: string;
    sipName: string;
    ownerCall: string;
}

export interface DataSortUserList {
    isArchived: boolean;
    pageNumber: number;
    pageSize: number;
    sort: {
        orderBy: string;
        isDesc: boolean;
    };
    filter?: { key: string; value: string }[];
}

export interface DataRow {
    item: {
        id: number;
        nameTo: string;
        number: string;
        contractNumber: string;
        campaignId: string;
        campaign: string;
        typeChannel: string;
        start: string;
        status: string;
        audioUrl: string;
        pathSegment: string;
        campaignName: string;
        fullName: string;
        isDeclined: boolean;
        duration: any;
        fullCallDuration: any;
        reactionClient: any;
        reactionOperator: any;
        amdHangup: boolean;
        callResetName: number;
        queueFullName: string | number;
        campaignFullName: string | number;
        branchId: string | number;
        branchName?: string | number;
        branchFullName?: string | number;
        direction: string | number;
    }
    children: [];
}

export interface DecodedToken {
    "x-access-userid"?: string;
    "exp"?: string
}

export interface CallOptions {
    mediaConstraints: {
        audio: object,
        video: any
    },
    pcConfig: {
        iceCandidatePoolSize: number,
        iceTransportPolicy: string,
        rtcpMuxPolicy: string,
        iceServers: any
    },
    extraHeaders: []
}
